/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TypeEvacuationDto } from '../models/type-evacuation-dto';


/**
 * Fonctions de gestion des types d'évacuation des recyparcs
 */
@Injectable({
  providedIn: 'root',
})
export class TypesEvacuationRecyparcsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation typeEvacuationParcGetListNoDestination
   */
  static readonly TypeEvacuationParcGetListNoDestinationPath = '/api/types-evacuation-recyparcs/list/{parcId}/no-destination';

  /**
   * Renvoie la liste des types d'évacuation qui n'ont pas de destination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeEvacuationParcGetListNoDestination()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeEvacuationParcGetListNoDestination$Response(params: {
    parcId: number;
  }): Observable<StrictHttpResponse<Array<TypeEvacuationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesEvacuationRecyparcsService.TypeEvacuationParcGetListNoDestinationPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeEvacuationDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'évacuation qui n'ont pas de destination.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeEvacuationParcGetListNoDestination$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeEvacuationParcGetListNoDestination(params: {
    parcId: number;
  }): Observable<Array<TypeEvacuationDto>> {

    return this.typeEvacuationParcGetListNoDestination$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeEvacuationDto>>) => r.body as Array<TypeEvacuationDto>)
    );
  }

}
